export const REUSABLE_FORM_FIELDS = {
  amount: 'amount',
  description: 'description',
  language: 'language',
  currency: 'currency'
};

export const REUSABLE_FORM_INITIAL_VALUES = {
  [REUSABLE_FORM_FIELDS.amount]: '',
  [REUSABLE_FORM_FIELDS.description]: '',
  [REUSABLE_FORM_FIELDS.language]: '',
  [REUSABLE_FORM_FIELDS.currency]: ''
};

export const AMOUNT_DEFAULT_VALUE = 0;

export const REUSABLE_FORM_NAME = 'reusableForm';

export const REUSABLE_AMOUNT_FIELD_MAX_LENGTH = 18;
